<mat-accordion class="repository-accordion">
  <mat-expansion-panel #tollFilterExpansionPanel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{ 'label.search' | translate }}
      </mat-panel-title>
      <mat-panel-description style="justify-content: flex-end;">
        {{ filterLabel }}
      </mat-panel-description>
    </mat-expansion-panel-header>
    <div>
      <form [formGroup]="tollGridFilterForm" style="display: flex; flex-wrap: wrap;">
        <div class="content-row">
          <label class="content-row-label">{{ 'label.site' | translate}}</label>
          <app-site-list [control]="$any(tollGridFilterForm).controls['site']" class="content-row-input"
            [pacoOnly]="true">
          </app-site-list>
        </div>
        <div class="content-row">
          <label class="content-row-label">{{ 'label.company' | translate}}</label>
          <app-company-list [control]="$any(tollGridFilterForm).controls['company']" class="content-row-input">
          </app-company-list>
        </div>

        <div class="content-row">
          <label class="content-row-label">{{ 'label.date' | translate}}</label>
          <mat-form-field class="content-row-input">
            <mat-date-range-input [rangePicker]="picker" formGroupName="range">
              <input matStartDate formControlName="start">
              <input matEndDate formControlName="end">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>

          </mat-form-field>
        </div>

        <div class="content-row">
          <label class="content-row-label">{{ 'label.type' | translate}}</label>
          <mat-select formControlName="isTruck" class="content-row-input">
            <mat-option value="">Tous</mat-option>
            <mat-option value="true">{{ 'label.truck' | translate }}</mat-option>
            <mat-option value="false">{{ 'label.car' | translate }}</mat-option>
          </mat-select>
        </div>

        <div class="content-row">
          <label class="content-row-label">{{ 'label.is-exeptionnal-convoy' | translate}}</label>
          <mat-select formControlName="isExceptionalConvoy" class="content-row-input">
            <mat-option value="">Tous</mat-option>
            <mat-option value="true">{{ 'button.yes' | translate }}</mat-option>
            <mat-option value="false">{{ 'button.no' | translate }}</mat-option>
          </mat-select>
        </div>

        <div class="content-row">
          <label class="content-row-label">{{ 'label.material' | translate}}</label>
          <app-material-list [control]="$any(tollGridFilterForm).controls['material']" class="content-row-input">
          </app-material-list>
        </div>

        <div class="content-row">
          <label class="content-row-label">{{ 'label.billed' | translate}}</label>
          <mat-select formControlName="billed" class="content-row-input">
            <mat-option value="">Tous</mat-option>
            <mat-option value="true">{{ 'button.yes' | translate }}</mat-option>
            <mat-option value="false">{{ 'button.no' | translate }}</mat-option>
          </mat-select>
        </div>

        <div class="content-row">
          <label class="content-row-label">{{ 'label.in-error' | translate}}</label>
          <mat-select formControlName="isError" class="content-row-input">
            <mat-option value="">Tous</mat-option>
            <mat-option value="true">{{ 'button.yes' | translate }}</mat-option>
            <mat-option value="false">{{ 'button.no' | translate }}</mat-option>
          </mat-select>
        </div>


        <div style="display: flex;
        padding: 0px 20px;
        justify-content: flex-end;
        width: 100%;">
          <button mat-raised-button color="primary" (click)="onClearFilter()" style="margin-right: 10px;">
            <mat-icon>clear</mat-icon>
            {{ 'button.clear-filter' | translate }}
          </button>
          <button mat-raised-button color="primary" (click)="onFilter()">
            <mat-icon>search</mat-icon>
            {{ 'button.search' | translate }}
          </button>

        </div>
      </form>
    </div>
  </mat-expansion-panel>
</mat-accordion>

<table mat-table [dataSource]="dataSource" matSort style="width: 100%; margin-top: 5px;" matSortActive="creationDate"
  matSortDirection="desc">

  <!-- Checkbox Column -->
  <ng-container matColumnDef="select">
    <th mat-header-cell *matHeaderCellDef>
      <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()"
        [indeterminate]="selection.hasValue() && !isAllSelected()">
      </mat-checkbox>
    </th>
    <td mat-cell *matCellDef="let row">
      <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
        [checked]="selection.isSelected(row)">
      </mat-checkbox>
    </td>
  </ng-container>

  <!-- siteName Column -->
  <ng-container matColumnDef="siteName">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.site' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.siteName }}</span>
    </td>
  </ng-container>

  <!-- companyName Column -->
  <ng-container matColumnDef="companyName">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.company' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.companyName }}</span>
    </td>
  </ng-container>

  <!-- date Column -->
  <ng-container matColumnDef="date">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.date' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.date | date : 'dd/MM/yy'}}</span>
    </td>
  </ng-container>

  <!-- isTruck Column -->
  <ng-container matColumnDef="isTruck">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.type' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ (element.isTruck ? 'label.truck' : 'label.car') | translate }}</span>
    </td>
  </ng-container>

  <!-- plate Column -->
  <ng-container matColumnDef="plate">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.plate' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.plate }}</span>
    </td>
  </ng-container>

  <!-- isExceptionalConvoy Column -->
  <ng-container matColumnDef="isExceptionalConvoy">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.is-exeptionnal-convoy' | translate}}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ (element.isExceptionalConvoy ? 'button.yes' : 'button.no') | translate }}</span>
    </td>
  </ng-container>

  <!-- quantity Column -->
  <ng-container matColumnDef="quantity">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.quantity' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.quantity | number :'0.0' :'fr' }} t</span>
    </td>
  </ng-container>

  <!-- material Column -->
  <ng-container matColumnDef="material">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.material' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.material }}</span>
    </td>
  </ng-container>

  <!-- creationDate Column -->
  <ng-container matColumnDef="creationDate">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.encoding' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.creationDate | date : 'dd/MM/yy HH:mm'}}</span>
    </td>
  </ng-container>

  <!-- error Column -->
  <ng-container matColumnDef="error">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.in-error' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <button mat-mini-fab (click)="onErrorClick(element)" type="button" *ngIf="element?.isError" color="warn">
        <mat-icon>announcement</mat-icon>
      </button>
    </td>
  </ng-container>

  <!-- action Column -->
  <ng-container matColumnDef="action">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div style="width: 100%;">
        <button mat-raised-button (click)="$event.preventDefault();exportExcel()" style="height: 30px;
        line-height: 30px; float: right;" [disabled]="selection.selected.length == 0">
          <mat-icon>move_to_inbox</mat-icon>{{ 'button.exportSelection' | translate }}
        </button>
      </div>
    </th>
    <td mat-cell *matCellDef="let element">
      <button mat-raised-button color="warn" (click)="onReportAnError(element)">
        <mat-icon>info</mat-icon>
        {{ 'button.report-an-error' | translate }}
      </button>
      <button mat-raised-button color="primary" (click)="onEdit(element)"
        *ngIf="uiService.isSupervision() && !element.billed" [matTooltip]="'button.edit' | translate">
        <mat-icon>edit</mat-icon>
      </button>
      <button mat-raised-button color="primary" (click)="onEdit(element)" *ngIf="element.billed"
        [matTooltip]="'button.detail-display' | translate">
        <mat-icon>list_alt</mat-icon>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'highlight': selectedRowID == row.id}"
    (click)="selectItemClick(row)"></tr>
</table>
<mat-paginator class="m-5 mat-elevation-z2" [pageSizeOptions]="pageSizeOptions" showFirstLastButtons>
</mat-paginator>